/**
 * 动态适配单选框，默认以单选组展示
 */

import { RadioGroup } from '@tencent/udesign/dist';
import {
  getDynamicRadioValue,
  isRadioComponent,
  randomStr,
} from '../../../libs';
import { IConfigField, IValue } from '../../../model';

interface IProps<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicRadio = <T,>(props: IProps<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;

  // Filters
  if (isFilterModeView) {
    const filterOptExtension = isRadioComponent(fieldConfig.filterOptExtension);
    if (!filterOptExtension) {
      return null;
    }

    const options = fieldConfig?.fieldOptExtension?.data || [];
    const newValue = getDynamicRadioValue(selectedValue);
    const onChanged = (value: string) => {
      props.onChanged(fieldConfig.key, value);
    };

    return (
      <RadioGroup
        name={filterOptExtension.groupName || randomStr('radioGroup')}
        value={newValue}
        options={options.slice()}
        onChange={onChanged}
        {...filterOptExtension}
      />
    );
  }

  return <span>{selectedValue.value}</span>;
};
